import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

export function useReducedMotion() {
  const [reduced, setReduced] = useState(() => window.matchMedia?.(QUERY)?.matches || false);
  useEffect(() => {
    const media = window.matchMedia?.(QUERY);
    if (!media) return;
    const changed = () => setReduced(media.matches);
    media.addEventListener?.("change", changed);
    return () => media.removeEventListener?.("change", changed);
  }, []);
  return reduced;
}
